import { LOGOUT, SET_CURRENT_MEAL_RESERVATION, RESET_CURRENT_MEAL_RESERVATION, SET_MEAL_RESERVATIONS_LIST } from "../actions/types";

const INITIAL_STATE = {
    current: {
        orderID: null,
        totalPrice: null,
        foundedPrice: null,
        soup: null,
        main: null,
        salad: null,
        extra: null
    },
    list: {}
};

const mealReservationReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_CURRENT_MEAL_RESERVATION:
            return {
                ...state,
                current: {
                    orderID: action.payload.orderID,
                    totalPrice: action.payload.totalPrice,
                    foundedPrice: action.payload.foundedPrice,
                    soup: action.payload.soup ? {
                        posID: action.payload.soup.posID,
                        description: action.payload.soup.description
                    } : null,
                    main: action.payload.main ? {
                        posID: action.payload.main.posID,
                        description: action.payload.main.description
                    } : null,
                    salad: action.payload.salad ? {
                        posID: action.payload.salad.posID,
                        description: action.payload.salad.description
                    } : null,
                    extra: action.payload.extra ? {
                        posID: action.payload.extra.posID,
                        description: action.payload.extra.description
                    } : null
                }
            };
        case RESET_CURRENT_MEAL_RESERVATION:
            return {
                ...state,
                current: INITIAL_STATE.current
            };
        case SET_MEAL_RESERVATIONS_LIST:
            return {
                ...state,
                list: mapObject(action.payload, mealReservation => {
                    return {
                        posDescription: mealReservation.posDescription,
                        count: mealReservation.count
                    };
                })
            };
        case LOGOUT:
            return INITIAL_STATE;
        default:
            return state;
    }
};

const mapObject = (source, action) => {
    const output = {};
    for (const key in source) {
        output[key] = source[key].map(action);
    }
    return output;
};

export default mealReservationReducer;